import { lazy } from 'react'
import { DEFAULT_GAME_ID, ROUTE_PATHS } from 'utils/constants/index'

const NewCrashGame = lazy(() => import('pages/NewCrashGame/index'))
const MineGame = lazy(() => import('pages/MineGame/index'))
const PlinkoGame = lazy(() => import('pages/PlinkoGame/index'))
const BlackjackGame = lazy(() => import('pages/BlackjackGame/index'))
const RouletteGame = lazy(() => import('pages/RouletteGame/index'))
const ErrorPage = lazy(() => import('pages/ErrorPage/index'))

const routesList = [
  {
    path: ROUTE_PATHS.crashGame,
    component: NewCrashGame,
    gameId: DEFAULT_GAME_ID.CRASH,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.mineGame,
    component: MineGame,
    gameId: DEFAULT_GAME_ID.MINE,
    isPrivate: false,
    isHeader: false,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.plinkoGame,
    component: PlinkoGame,
    gameId: DEFAULT_GAME_ID.PLINKO,
    isPrivate: false,
    isHeader: false,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.blackjackGame,
    component: BlackjackGame,
    gameId: DEFAULT_GAME_ID.BLACKJACK,
    isPrivate: false,
    isHeader: false,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.rouletteGame,
    component: RouletteGame,
    gameId: DEFAULT_GAME_ID.ROULETTE,
    isPrivate: false,
    isHeader: false,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.error,
    component: ErrorPage,
    isPrivate: false,
    isHeader: false,
    isFooter: false,
    showSidebar: false
  }
]

export default routesList
